import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';

@Component({
  selector: 'app-tot',
  standalone: false,
  templateUrl: './tot.component.html',
})
export class TotComponent implements OnInit {
  commentForm: FormGroup;
  @Output() routeConfig = new EventEmitter<any>();
  @Input() stepDetails: any;
  @Input() proposalName: any;
  @Input() url: string;
  apiResponse: any;
  init: EditorComponent['init'] = init;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: ApiService
  ) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getDetails();
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.commentForm.enable();
      } else {
        this.commentForm.disable();
      }
    }, 3000);
  }

  onSubmit(): void {
    const formData = new FormData();
    formData.append('proposal_step', this.stepDetails.id);
    formData.append('comment', this.commentForm.get('comment')?.value || '');
    const req = this.apiResponse?.id
      ? this.api.putAPI(`${this.url}${this.apiResponse.id}/`, formData)
      : this.api.postAPI(this.url, formData);
    req.subscribe((res: any) => {
      this.getDetails();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || (this.apiResponse?.id ? 'Data updated successfully' : 'Data uploaded successfully')
      });
    });
  }

  getDetails(): void {
    this.api.getAPI(`${this.url}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`)
      .subscribe((res: any) => {
        this.apiResponse = res[0];
        this.commentForm.patchValue(this.apiResponse);
      });
  }
}
